import {
  UilChartPie
} from '@iconscout/react-unicons';
import { RouteItems } from './types/route-types';

export const routes: RouteItems[] = [
  {
    label: '',
    horizontalNavLabel: '',
    active: true,
    icon: UilChartPie,
    labelDisabled: true,
    pages: [
      {
        name: 'Home',
        path: '/',
        pathName: 'default-dashboard',
        icon: 'home',
        active: true
      }
    ]
  },   
  {
    label: '',
    horizontalNavLabel: '',
    active: true,
    icon: UilChartPie,
    labelDisabled: true,
    pages: [
      {
        name: 'Connectors',
        path: '/connector-management',
        pathName: 'connector-management',
        active: true,
        icon: 'link-2'
      }
    ]
  },   
  {
    label: '',
    horizontalNavLabel: '',
    active: true,
    icon: UilChartPie,
    labelDisabled: true,
    pages: [
      {
        name: 'Groups',
        path: '/group-management',
        pathName: 'group-management',
        active: true,
        icon: 'folder'
      }
    ]
  },
  {
    label: '',
    horizontalNavLabel: '',
    active: true,
    icon: UilChartPie,
    labelDisabled: true,
    pages: [
      {
        name: 'Explore',
        path: '/explore',
        pathName: 'explore',
        active: true,
        icon: 'compass'
      }
    ]
  },   
  {
    label: '',
    horizontalNavLabel: '',
    active: true,
    icon: UilChartPie,
    labelDisabled: true,
    pages: [
      {
        name: ' Data Access',
        path: '/Data-Access',
        pathName: 'Data-Access',
        active: true,
        icon: 'key'
      }
    ]
  }
];

